import React from 'react';
import { Styled } from './index.styles';
import { BodyProps } from './index.types';

export const Body = ({ children, ...props }: BodyProps) => {
  return <Styled.Body {...props}>{children}</Styled.Body>;
};
